{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Lihat Semua Opsi",
  "Spoiler_Reveal_Tooltip": "Klik untuk mengungkap",
  "VerticalEmbed_Event_Error_Subtitle": "Event ini telah dihapus, ganti dengan event lain.",
  "Viewer_Toolbar_Twitter_Tooltip": "Twitkan ini",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Item ditutup",
  "Spoiler_Reveal_Video_CTA": "Singkap Video",
  "VerticalEmbed_Pricing_Plan": "Hanya paket",
  "Image_Expand_Button_AriaLabel": "Perluas gambar",
  "VerticalEmbed_From_Price": "Mulai",
  "Poll_Viewer_ShowAllResults_CTA": "Lihat Semua Hasil",
  "Spoiler_Reveal_Image_Placeholder": "Gambar ini berisi bocoran",
  "VerticalEmbed_Ribbon": "Promosi",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Cari penggeser",
  "VerticalEmbed_Error_Subtitle": "Item ini telah dihapus, ganti dengan item lain.",
  "Poll_Viewer_Multiselect_Footer": "Anda boleh memberikan suara ke lebih dari satu jawaban.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Tampilkan kontrol audio lainnya",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Layanan tidak dapat dimuat",
  "Fullscreen_Close_Button_AriaLabel": "Tutup",
  "VerticalEmbed_Event_Fetch_Error_Title": "Event tidak dapat dimuat",
  "UploadFile_Viewer_Loader": "Memuatkan {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar pengguna",
  "Preview_ReadMore_Label": "Teks lengkap",
  "Spoiler_Insert_Tooltip": "Bocoran",
  "VerticalEmbed_Product_Fetch_Error_Title": "Produk tidak dapat dimuat",
  "Fullscreen_Shrink_Button_AriaLabel": "Menyusut",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Galeri ini berisi bocoran",
  "Fullscreen_Expand_Button_AriaLabel": "Bentangkan",
  "VerticalEmbed_Bookings_Button": "Pesan Sekarang",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Aktifkan suara",
  "Spoiler_Reveal_Gallery_CTA": "Singkap Galeri",
  "Poll_Viewer_ShowLess_CTA": "Tampilkan lebih sedikit",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Bisukan",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} anonim",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Ikuti",
  "VerticalEmbed_Products_Button": "Beli Sekarang",
  "Poll_Viewer_Toast_Error_ServerDown": "Tidak dapat menyambung dengan server. Coba lagi nanti.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} orang memberikan suara untuk jawaban ini",
  "Poll_Viewer_VoteCount": "{{number}} suara",
  "VerticalEmbed_Events_Button": "Daftar Sekarang",
  "Spoiler_Reveal_Image_CTA": "Singkap Gambar",
  "Poll_Viewer_Toast_Error_Connection": "Tidak ada internet. Periksa sambungan Anda.",
  "Poll_Viewer_Visibility_Owner_Footer": "Hanya Anda yang bisa melihat hasilnya.",
  "VerticalEmbed_Booking_Error_Title": "Layanan dihapus",
  "VerticalEmbed_Product_Error_Title": "Produk dihapus",
  "VerticalEmbed_Fetch_Error_Subtitle": "Tidak dapat memuat informasi item.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} orang memberikan suara untuk jawaban ini",
  "VerticalEmbed_Event_Error_Title": "Event dihapus",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Item dibentangkan",
  "Audio_Plugin_Cover_Alt": "Penutup audio",
  "Spoiler_Reveal_Video_Placeholder": "Video ini berisi bocoran",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Terjadi masalah teknis. Periksa koneksi Anda atau coba lagi.",
  "VerticalEmbed_Fetch_Error_Title": "Gagal memuat item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Produk ini telah dihapus, ganti dengan produk lain.",
  "VerticalEmbed_Booking_Error_Subtitle": "Layanan ini telah dihapus, ganti dengan layanan lain.",
  "Preview_SeeFullPost_Label": "Lihat postingan lengkap",
  "UploadFile_Viewer_Download": "Unduh {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}}j",
  "VerticalEmbed_Units_Minute": "{{minutes}}mnt",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Terjadi masalah teknis. Periksa koneksi Anda atau coba lagi.",
  "VerticalEmbed_Error_Button": "Ganti",
  "VerticalEmbed_Error_Title": "Item dihapus",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Terjadi masalah teknis. Periksa koneksi Anda atau coba lagi.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
